const PLAYER_CALENDAR_PAST_DAYS = 7;

export function playerCalendarDays(localToday) {
  return Array.from(
    { length: 22 },
    (_, index) => localToday.add(index - PLAYER_CALENDAR_PAST_DAYS, "day"),
  );
}

export function todayLeftScrollPosition(todayOffsetLeft, calendarOffsetLeft = 0) {
  return Math.max(0, todayOffsetLeft - calendarOffsetLeft);
}
